export default "__VITE_ASSET__00184736__"